<template>
    <div class="bwg_manage">
        <div class="elec_right">
            <div class="elec_right_item" v-for="item in datas" :key="item" @click="goDetail(item)">
                <div class="elec_right_title">{{item.name}}</div>
                <img class="elec_mac" src="../../../assets/image/custom/bwg_mac.png"/>
                <!-- <div class="elec_title_div">
                    <img class="elec_title" src="../../../assets/image/custom/elec_title.png"/>
                    <span>{{item.name}}</span>
                </div> -->
                <div class="elec_item_inner">
                    <div class="inner_item">
                        <div>{{ $t('bwgManage.dianliu') }}：</div>
                        <div><span class="red">A:</span><i>{{item.a_a}}</i>&nbsp;A</div>
                        <div><span class="green">B:</span><i>{{item.a_b}}</i>&nbsp;A</div>
                        <div><span class="yellow">C:</span><i>{{item.a_c}}</i>&nbsp;A</div>
                    </div>
                    <div class="inner_item">
                        <div>{{ $t('bwgManage.dianya') }}：</div>
                        <div><span class="red">A:</span><i>{{item.v_a}}</i>&nbsp;V</div>
                        <div><span class="green">B:</span><i>{{item.v_b}}</i>&nbsp;V</div>
                        <div><span class="yellow">C:</span><i>{{item.v_c}}</i>&nbsp;V</div>
                    </div>
                    <div class="inner_item">
                        <div>{{ $t('bwgManage.yougonggonglv') }}：</div>
                        <div><i>{{item.p}}</i>&nbsp;kW</div>
                    </div>
                    <div class="inner_item">
                        <div>{{ $t('bwgManage.wugonggonglv') }}：</div>
                        <div><i>{{item.q}}</i>&nbsp;kvar</div>
                    </div>
                    <div class="inner_item">
                        <div>{{ $t('bwgManage.gonglvyinshu') }}：</div>
                        <div><i >{{item.pf}}</i></div>
                    </div>
                    <div class="inner_item">
                        <div>{{ $t('bwgManage.dayelec') }}：</div>
                        <div><i>{{item.elecDay}}</i>&nbsp;{{item.dayUnit}}</div>
                    </div>
                    <div class="inner_item">
                        <div>{{ $t('bwgManage.monthelec') }}：</div>
                        <div><i>{{item.elecMonth}}</i>&nbsp;{{item.monthUnit}}</div>
                    </div>
                    <div class="inner_item">
                        <div>{{ $t('bwgManage.yearelec') }}：</div>
                        <div><i>{{item.elecYear}}</i>&nbsp;{{item.yearUnit}}</div>
                    </div>
                    <!-- <div class="inner_item">
                        <div>运行状态</div>
                        <div v-if="item.run == 1"><img class="inner_pic" src="../../../assets/image/custom/run_pic.png" /></div>
                        <div v-else><img class="inner_pic" src="../../../assets/image/custom/run_pic_u.png" /></div>
                    </div> -->
                    <!-- <div class="inner_item">
                        <div>加载状态</div>
                        <div v-if="item.run == 1"><img class="inner_pic"  src="../../../assets/image/custom/loading_pic.png" /></div>
                        <div v-else><img class="inner_pic"  src="../../../assets/image/custom/loading_pic_u.png" /></div>
                    </div> -->
                    <!-- <div class="inner_item" style="position: relative">
                        <img class="more_pic" src="../../../assets/image/custom/more_pic.png" />
                        <span class="more_pic_txt">更多</span>
                    </div> -->
                </div>
                
            </div>
            <div class="elec_right_item" style="background: none">
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/chart/gauge";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/graphic";
import utils from "@/utils/utils.js";
import { getDataAll } from "@/http/http-60.js";
import dayjs from "dayjs";
import * as api from "../../../http/Use_electricity_monitor";
import { dayTransfer, monthTransfer } from "@/utils/dateTransfer.js";
import unitUtils from "@/utils/unit-exchange.js";
export default {
    data() {  
        return {
            datas: [
                {point_id: '1658033542455869440',point_60_id: '1694514394265968640',name: this.$t('bwgManage.PVCS1'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658347145876717568',point_60_id: '1694515869994082304',name: this.$t('bwgManage.PVCS2'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658348663564648448',point_60_id: '1694516000688594944',name: this.$t('bwgManage.PVCS3'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658349600567967744',point_60_id: '1694516134243622912',name: this.$t('bwgManage.PVCS4'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658349706910351360',point_60_id: '1694516262157312000',name: this.$t('bwgManage.PVCS5'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658349801424797696',point_60_id: '1694516514520195072',name: this.$t('bwgManage.PVCS6'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658349883876425728',point_60_id: '1694516642161254400',name: this.$t('bwgManage.PVCS7'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658349967154331648',point_60_id: '1694516751854886912',name: this.$t('bwgManage.PVCS8'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658351454773297152',point_60_id: '1694516897531453440',name: this.$t('bwgManage.PVCS9'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
                {point_id: '1658351554169913344',point_60_id: '1694517034207043584',name: this.$t('bwgManage.PVCS10'), elecDay: '', elecMonth: '', elecYear: '', dayUnit: '', monthUnit: '', yearUnit: '', a_a: '',a_b: '',a_c: '', v_a: '68', v_b: '10', v_c: '0', pf: '0', p: '0', q: '0'},
            ],
            timer: null,
            monitorData: {
                run: 0,
                load: 0,
                stop: 0,
                unload: 0,
            },
            nenghaoData: {
                elecDay: 0,
                elecMonth: 0,
                elecYear: 0,
                dayUnit: '',
                monthUnit: '',
                yearUnit: '',
            },
            day_xAxis: [],
            day_series: [
                {
                    name: this.$t('bwgManage.sharpPower'),
                    type: "bar",
                    stack: "elc",
                    data: [],
                    itemStyle: {
                        color: "#fe7f66"
                    }
                },
                {
                    name: this.$t('bwgManage.peakPower'),
                    type: "bar",
                    stack: "elc",
                    data: [],
                    itemStyle: {
                        color: "#fdca50"
                    }
                },
                {
                    name: this.$t('bwgManage.valleyPower'),
                    type: "bar",
                    stack: "elc",
                    data: [],
                    itemStyle: {
                        color: "#29b85e"
                    }
                }
            ],
        };
    },
    created() {
        this.getData();
        // this.getElecInfo();
        this.setTimer();
    },
    methods: {
        goDetail(item) {
            sessionStorage.setItem("activeTab", JSON.stringify({ name:'bwg_power_manage', query:{ point_id: item.point_id, point_60_id: item.point_60_id, bwg_name: item.bwg_name }}));
            this.$router.push({ name:'bwg_power_manage', query:{ point_id: item.point_id, point_60_id: item.point_60_id, bwg_name: item.name } })
        },
        setTimer() {
            console.log(this.timer)
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                this.getData();
                // this.getElecInfo();
            }, 5000*12);
        },
        getData() {

            this.datas.forEach(item => {

                api.getElecInfo({
                    point_id: item.point_id,
                    date: dayjs(new Date()).format("YYYY-MM-DD")
                }).then(res => {
                    if (res && res.error_code === "0") {
                        item.elecDay = res.bus_json.active_power_day;
                        item.elecMonth = res.bus_json.active_power_month;
                        item.elecYear = res.bus_json.active_power_year;
                        item.dayUnit = res.bus_json.dayUnit;
                        item.monthUnit = res.bus_json.monthUnit;
                        item.yearUnit = res.bus_json.yearUnit;
                    }
                });
                let pointIds=[];
                pointIds.push(item.point_60_id);
                getDataAll(pointIds).then(res => {
                    if (undefined !== res.bus_json) {
                        let valueJson = res.bus_json;
                        let point = valueJson[item.point_60_id];
                        item.a_a = point && point.a_a;
                        item.a_b = point && point.a_b;
                        item.a_c = point && point.a_c;
                        item.v_a = point && point.v_a;
                        item.v_b = point && point.v_b;
                        item.v_c = point && point.v_c;
                        item.p = point && point.p;
                      //  item['p'] = unitUtils.exchangeUnitKW(item.p).num;
                        item.q = point && point.q;
                      //  item['q'] = unitUtils.exchangeUnitKW(item.q).num;
                        item.pf = point && point.pf;
                    }
                });


            });

        },
        destroyed() {
            clearInterval(this.timer);
        }
    },
    computed: {
        language() {
            return this.$store.state.language.language;
        },
        dayBar() {
            const options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: [this.$t('bwgManage.sharpPower'), this.$t('bwgManage.peakPower'), this.$t('bwgManage.valleyPower')],
                    itemWidth: 10,
                    itemHeight: 10,
                    textStyle: {
                        color: utils.getFontColor()
                    }
                },
                grid: {
                    left: "2%",
                    right: "2%",
                    bottom: "5%",
                    top: "20%",
                    containLabel: true
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.day_xAxis,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "kW·h",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: utils.getFontColor() // 颜色
                            }
                        }
                    }
                ],
                series: this.day_series
            };
            return options;
        },
    },
    destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss">
.bwg_manage {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: inline-flex;
    padding: 0 1rem;
    i {
        color: #56FCFF;
    }
    .elec_left_title {
        //  background: url(../../../assets/image/custom/elec_left_line.png) no-repeat;
        color: #56FCFF;
        //  background-size: 100% 100%;
        text-align: center;
        // height: 0.5rem;
        // width: 100%;
        width: 100%;
        height: 2.5rem;
        position: relative;
        span {
            position: absolute;
            top: 50%; 
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 1rem;
        }
        img {
            width: 100%;
            height: auto;
            position: absolute;
            top: 50%; 
            left: 0;
            transform: translate(0, -50%);
        }
    }
    .elec_common_item {
        display: inline-flex;
        flex-flow: column wrap;
        justify-content: space-evenly;
        width: 100%;
        height: calc(100% - 2rem);
        .elec_common_item_line {
            flex: 1;
            display: inline-flex;
            width: 100%;
            align-items: center;
            font-size: 0.8rem;
            div {
                //flex: 1;
                font-size: 0.8rem;
                line-height: 1.7rem;
                &:last-child {
                    text-align: right;
                }
                img {
                    width: 1rem;
                    height: 1rem;
                }
            }
        }
        .left_top {
            display: inline-flex; 
            flex-flow: column wrap; 
            justify-content: space-between; 
            align-items: flex-start;
            .left_top_chart {
                width: 100%;
                height: calc(100% - 1.7rem);
                .echarts {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .elec_custom_line {
            display: inline-flex;
            width: 100%;
            align-items: center;
            font-size: 0.8rem;
            .elec_item_line_pic {
                width: 1rem;
                img {
                    width: 0.8rem;
                }
            }
            .elec_item_line_cnt {
                width: 50%;
            }
        }
        .elec_custom {
            width: 50%; 
            flex: none !important
        }
    }
    .elec_left {
        width: 24%;
        margin-right: 3%;
        display: inline-flex;
        flex-flow: column wrap;
        justify-content: space-between;
        .elec_left_top {
            width: 100%;
            height: 28%;
            background: url(../../../assets/image/custom/elec_left_top.png) no-repeat;
            color: #fff;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 0.6rem 2rem 1.2rem;
        }
        .elec_left_center {
            width: 100%;
            height: 20%;
            background: url(../../../assets/image/custom/elec_left_center.png) no-repeat;
            color: #fff;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 0.6rem 2rem 1.2rem;
        }
        .elec_left_bottom {
            width: 100%;
            height: 48%;
            background: url(../../../assets/image/custom/elec_left_bottom.png) no-repeat;
            color: #fff;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 0.6rem 2rem;
            .left_bottom_choose {
                width: 100%; display: inline-flex;justify-content: space-evenly;
                div {
                    width: 3rem;height: 1rem; border: 1px solid #56fcff; border-radius: 1rem; text-align: center; font-size: 0.8rem; line-height: 1rem;
                }
                .choose_s {
                    background: #56fcff;
                    color: #000;
                }
                .choose_us {
                    background: transparent;
                    color: #fff;
                }
            }
        }        
        .elec_chart_div {
            width: 100%;
            height: calc(100% - 4rem);
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
    .elec_right {
        flex: 1;
        display: inline-flex;
        flex-flow: row wrap;
       // justify-content: space-evenly;
        .elec_right_item {
            width: 18%;
            height: 48%;
            background: url(../../../assets/image/custom/bwg_rect.png) no-repeat;
            color: #fff;
            background-size: 100% 100%;
            box-sizing: border-box;
            padding: 2rem 2rem 1rem 2rem;
            margin: 1% 1% 0 1%;
            cursor: pointer;
            position: relative;
            .elec_right_title {
                position: absolute; 
                top: 3%;
                left: 17%;
                font-size: 0.8rem;
            }
            .elec_mac {
                width: auto;
                height: 6.5rem;
                margin: 0 50%;
                transform: translate(-40%, 0);
            }
            .elec_title_div {
                width: 100%;
                position: relative;
                span {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    color: #56FCFF;
                    font-size: 0.6rem;
                }
                .elec_title {
                    width: 80%;
                    margin-left: 10%;
                    height: 1.2rem;
                }

            }
            .elec_item_inner {
                width: 100%;
                height: calc(100% - 6rem);
                display: inline-flex;
                justify-content: space-evenly;
                flex-flow: column wrap;
                .inner_item {
                    font-size: 0.7rem;
                    display: inline-flex;
                    div {
                        flex: 1;
                        height: 0.7rem;
                        &:not(:first-child) {
                            text-align: right;
                        }
                        .inner_pic {
                            width: 0.8rem;
                            height: 0.8rem;
                        }
                    }
                    .more_pic {
                        width: 100%;
                        height: auto;
                        
                    }
                    .more_pic_txt {
                        position: absolute; 
                        top: 50%;
                        left: 50%;
                        color: #fff; 
                        font-size: 0.7rem; 
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
        .red {
            color: red;
        }
        .green {
            color: #04c40e;
        }
        .yellow {
            color: yellow;
        }
    }
}
</style>
